export default "__VITE_ASSET__DyjgtE9e__"